import script from "./OverseaProductSku.vue?vue&type=script&lang=ts&setup=true"
export * from "./OverseaProductSku.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__